import { render, staticRenderFns } from "./title.vue?vue&type=template&id=52664734&scoped=true&"
import script from "./title.vue?vue&type=script&lang=ts&"
export * from "./title.vue?vue&type=script&lang=ts&"
import style0 from "./title.vue?vue&type=style&index=0&id=52664734&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52664734",
  null
  
)

export default component.exports